<template>
  <div class="card-company">
    <CardSingleCompanyLink
      v-if="isEmployee && isTeamDashboard"
      class="card-company__link"
      :title="account.name"
      :text="account.name"
      :to="{
        name: 'dashboard-client',
        params: { account_id: account.id },
      }"
      data-jest="company-link"
    />

    <CardSingleCompanyName v-else :name="account.name" />
  </div>
</template>

<script>
// Utilities
import { authComputed } from 'Store/helpers'
// Components
import CardSingleCompanyLink from './CardSingleCompanyLink'
import CardSingleCompanyName from './CardSingleCompanyName'

export default {
  name: 'CardSingleCompany',

  components: {
    CardSingleCompanyLink,
    CardSingleCompanyName,
  },
  props: {
    account: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...authComputed,
    isTeamDashboard() {
      return this.$route.matched.some((match) => match.path === '/dashboard')
    },
    isEmployee() {
      return this.userType === 'EMPLOYEE'
    },
  },
}
</script>

<style scoped>
.card-company {
  display: inherit;
  width: 100%;
  overflow: hidden;
}

.card-company__link,
.card-company__name {
  display: inline-block;
  width: 100%;
  font-size: 9px;
  line-height: 13px;
  font-weight: 700;
  letter-spacing: 1px;
  margin: 0;
  padding: 8px 10px 9px;
  color: var(--c-secondary-700);
  border-bottom-left-radius: 4px;
  border-bottom-left-radius: 4px;
  text-transform: uppercase;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

a.card-company__link:hover {
  background-color: var(--c-secondary-500);
}
</style>
